module.exports = __webpack_public_path__ + "static/media/angry.aab78a29.svg";